module.exports = __webpack_public_path__ + "static/4-ecc60b36f2b8419f5f96aff0b31a2ac6.jpg";